<template>
  <vSelect
    :options="cities"
    v-model="city"
    @search="search"
    :reduce="city => city"
    :filterable="false"
    :loading="loading"
    :required="required"
  >
    <template #no-options>
      <span v-if="loading">Завантаження...</span>
      <span v-else>{{ $filters.localize("select.noOptions") }}</span>
    </template>
  </vSelect>
</template>

<script>
import vSelect from "vue-select";
export default {
  name: "select-city",
  emits: ['update', "required"],
  props: { entity: Object },
  components: { vSelect },
  data() {
    return {
      cities: [],
      loading: false,
      searchTimeout: null,
      requestId: 0,
      abortController: null,
    };
  },
  computed: {
    city: {
      get() {
        return { code: this.entity.city, label: this.entity.cityName };
      },
      set(value) {
        this.$emit("update", value);
      }
    }
  },
  methods: {
    search(name) {
      const value = name?.trim();
      window.clearTimeout(this.searchTimeout);

      if (!value) {
        this.cities = [];
        this.cancelRequest();
        return;
      }

      this.searchTimeout = window.setTimeout(() => this.loadCities(value), 300);
    },
    async loadCities(name) {
      const requestId = ++this.requestId;
      this.cancelRequest();
      const controller = new AbortController();
      this.abortController = controller;
      this.loading = true;

      try {
        const result = await this.$store.dispatch('getAPI', { controller: "address", method: "cities/" + name, signal: controller.signal });
        if (requestId === this.requestId) {
          this.cities = (result.data.data[0]?.addresses ?? []).map(x => this.map(x));
        }
      } catch (error) {
        if (error.code !== "ERR_CANCELED") {
          throw error;
        }
      } finally {
        if (requestId === this.requestId) {
          this.loading = false;
          this.abortController = null;
        }
      }
    },
    cancelRequest() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
    },
    map(data) {
      return { code: data.deliveryCity, label: data.present };
    },
  },
  beforeUnmount() {
    window.clearTimeout(this.searchTimeout);
    this.cancelRequest();
  },
};
</script>
